import { VStack, theme } from '@squire/ui';

import { Skeleton } from '@/components/_shared/Skeleton';

export const CashAppQrCodeSkeleton = () => (
  <VStack centerVertical space={theme.spacing[5]}>
    <Skeleton variant="rectangular" width={280} height={280} />

    <Skeleton variant="text" width={'30%'} />

    <VStack space={theme.spacing[8]} paddingHorizontal={theme.spacing[5]}>
      <VStack space={theme.spacing[2]} centerVertical>
        <Skeleton variant="text" width={'70%'} />
        <Skeleton variant="text" width={'70%'} />
      </VStack>

      <VStack space={theme.spacing[2]} centerVertical>
        <Skeleton variant="text" width={'70%'} />
        <Skeleton variant="text" width={'70%'} />
      </VStack>
    </VStack>
  </VStack>
);
